  <webshop-catalog [catalog]="shownCatalog" [fetchInventoryDetails]="fetchInventoryDetails" [type]="type"></webshop-catalog>
    <div style="display: flex;
    justify-content: center; padding-top: 10px;">
      <a (click)="toggleShowAll()" style="cursor: pointer; padding: 10px; color: #106DBE;" *ngIf="shownCatalog.items.length < _catalog.items.length">{{'web.webshop.product.showmore'|lowercase | translate}}</a>
    </div>
